import React from "react";
import TexttileIndustryIcon from "../Assets/icons/Textile.gif";
import PharmaIcon from "../Assets/icons/Pharma.gif";
import defenceIcon from "../Assets/icons/Defence.gif";
import DairyIcon from "../Assets/icons/Dairy.gif";
import FoodIcon from "../Assets/icons/Food.gif";
import OilIcon from "../Assets/icons/OilandGas.gif";
import ChemicalIcon from "../Assets/icons/ChemicalPlants.gif";
import FiberIcon from "../Assets/icons/Manmadefiber.gif";

const IndustriesWeServe = () => {
  return (
    <div className="about-info-container" id="industries-we-serve">
      <p className="title-text-about">Industries We Serve</p>
      <p className="description-text text-center">Partnering with industries to make the impossible possible</p>
      <div className="container_industries_we_serve">
        <div className="industries_we_serve">
          <div>
            <img
              src={TexttileIndustryIcon}
              alt={"customer icon"}
              height={50}
              width={50}
            />
          </div>
          <p className="industries_we_serve_text m-0 ">
            Textile
            <br />
            Industry
          </p>
        </div>
        <div className="industries_we_serve">
          <div>
            <img
              src={PharmaIcon}
              alt={"customer icon"}
              height={50}
              width={50}
            />
          </div>
          <p className="industries_we_serve_text m-0">
            Pharmaceutical
            <br />
            Industry
          </p>
        </div>
        <div className="industries_we_serve">
          <div>
            <img
              src={defenceIcon}
              alt={"customer icon"}
              height={50}
              width={50}
            />
          </div>
          <p className="industries_we_serve_text  m-0">
            Defence
            <br />
            Sector
          </p>
        </div>
        <div className="industries_we_serve">
          <div>
            <img src={DairyIcon} alt={"customer icon"} height={50} width={50} />
          </div>
          <p className="industries_we_serve_text  m-0">
           
            Dairy<br />Industry
          </p>
        </div>
        <div className="industries_we_serve">
          <div>
            <img src={FoodIcon} alt={"customer icon"} height={50} width={50} />
          </div>
          <p className="industries_we_serve_text  m-0">
            Food
            <br />
            Processing
          </p>
        </div>
        <div className="industries_we_serve">
          <div>
            <img src={OilIcon} alt={"customer icon"} height={50} width={50} />
          </div>
          <p className="industries_we_serve_text  m-0">
            Oil and
            <br />
            Gas
          </p>
        </div>
        <div className="industries_we_serve">
          <div>
            <img
              src={ChemicalIcon}
              alt={"customer icon"}
              height={50}
              width={50}
            />
          </div>
          <p className="industries_we_serve_text  m-0">
            Chemical
            <br />
            Plants
          </p>
        </div>
        <div className="industries_we_serve">
          <div>
            <img src={FiberIcon} alt={"customer icon"} height={50} width={50} />
          </div>
          <p className="industries_we_serve_text  m-0">
            Man-Made
            <br />
            Fiber
          </p>
        </div>
      </div>
    </div>
  );
};

export default IndustriesWeServe;
